/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsSetClusterPrice } from "../../funcs/llmModelsSetClusterPrice.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.PutModelPriceBody$inboundSchema,
};

export const tool$llmModelsSetClusterPrice: ToolDefinition<typeof args> = {
  name: "llm-models-set-cluster-price",
  description: `Set a cluster-default model price

Upserts the cluster-default price for a model as a new dated version. \`rates\` is a flexible metric→rate map; omitted metrics are not charged.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsSetClusterPrice(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
